import { createContext } from "react";
import { SectionNavigationContextType as SectionNavigationContextInterface } from "./interfaces";

const SectionNavigationContext = createContext<
  Partial<SectionNavigationContextInterface>
>({});

export default SectionNavigationContext;
